<script>
import IconChevronDown from "@js/components/Icons/IconChevronDown.vue";

export default {
    name: "TextAccordion",
    components: {IconChevronDown},
    props: {
        text: {
            required: false,
            type: String,
        },
        minHeight: {
            required: false,
            type: Number,
            default: 150
        },
        isDefaultOpen: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isOpen: this.isDefaultOpen,
            maxHeight: 0,
        };
    },
    mounted() {
        this.updateMaxHeight();
    },
    methods: {
        toggleAccordion() {
            this.isOpen = !this.isOpen;
            if (this.isOpen) {
                this.$nextTick(() => {
                    this.updateMaxHeight();
                });
            }
        },
        updateMaxHeight() {
            if (this.$refs.content) {
                this.maxHeight = this.$refs.content.scrollHeight;
            }
        }
    }
}
</script>

<template>
    <div class="relative">
        <div class="content-container overflow-hidden" ref="content"
             :style="{
            'max-height': isOpen ? maxHeight + 'px' : minHeight + 'px'
         }">
            <template v-if="text">
                {{ text }}
            </template>
            <template v-else>
                <slot/>
            </template>
        </div>
        <div v-if="!isOpen" class="fade-mask"></div>
    </div>
    <p class="flex items-center text-sm font-bold mt-5 cursor-pointer text-gray-800 hover:text-indigo-600 transition"
       @click="toggleAccordion">
        {{ isOpen ? 'Скрыть' : 'Больше' }}
        <IconChevronDown class="w-4 h-4 ms-1" :class="{'rotate-180': isOpen}"/>
    </p>
</template>

<style scoped lang="scss">
.max-height-transition {
    transition: max-height .5s ease;
}

.content-container {
    transition: max-height 0.5s ease;
    overflow: hidden;
    position: relative;
}

/* Блюр и маска градиента */
.fade-mask {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 20px;
    /* Полупрозрачный фон */
    background: rgba(255, 255, 255, 0.1);

    /* Размытие заднего фона */
    backdrop-filter: blur(1px);
    pointer-events: none;
}
</style>
